export default __webpack_public_path__ + "static/media/@bc.eloa.112a6139.PNG";